import React, { useEffect, useState } from "react";
import { Button, Typography, Form, Select, Input, Tag, notification } from "antd";
import { get, post } from "../../../api/axios";
import { Link } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";
import { onChangeTableHelper } from "../../control-sections/helper/TableHelpers";
import TableComponent from "../../control-sections/helper/TableComponent";

const InvestRequests = () => {
    const { Title, Paragraph } = Typography;
    const [form] = Form.useForm();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const [total, setTotal] = useState(1);

    const columns = [
        {
            title: " Id",
            dataIndex: "id",
            sorter: (a, b) => a.id - b.id,
        },
        {
            title: " user name",
            render: ({ user }) => (
                <>
                    {user.name ?? "username"}
                </>
            )
        },
        {
            title: " user email",
            render: ({ user }) => (
                <>
                    {user.email ?? "email"}
                </>
            )
        },
        {
            title: " user phone",
            render: ({ user }) => (
                <>
                    {user.phone ?? "phone number"}
                </>
            )
        },
        {
            title: "Neighborhood",
            dataIndex: "neighborhood",
        },
        {
            title: "Specifications",
            render: ({ specifications }) => (
                <div className="border rounded text-start" style={{width: '130px'}}>
                    {
                        specifications.map(item => (
                            <div className="border-bottom px-3 pt-2">
                                <Paragraph>Question:  {item.question_id} </Paragraph>
                                <Paragraph>Answers:  {item.answers} </Paragraph>
                            </div>
                        ))
                    }
                </div>
            )
        },
        {
            title: 'user interests',
            render: ({ user_interests }) => (
                <div style={{ width: '300px' }}>
                    <>
                        {
                            user_interests[0] &&
                            <>
                                {user_interests[0].neighborhood} - {user_interests[0].statistic} - {user_interests[0].unit_type} 
                                <br />

                            </>
                        }
                        {
                            user_interests[1] &&
                            <>
                                {user_interests[1].neighborhood} - {user_interests[1].statistic} - {user_interests[1].unit_type} 
                                <br />
                            </>
                        }
                        {
                            user_interests[2] &&
                            <>
                                {user_interests[2].neighborhood} - {user_interests[2].statistic} - {user_interests[2].unit_type}

                            </>
                        }

                    </>

                </div>
            )
        },
        {
            title: "Is Contacted",
            render: ({ is_contacted }) => (
                <>
                    <Tag color={`${is_contacted ? "success" : "error"}`}>
                        {String(is_contacted)}
                    </Tag>
                </>
            ),
        },
        {
            title: "Created at",
            render: ({ created_at }) => (
                <>
                    {created_at}
                </>
            ),
        },
    ];

    if (
        checkPermission("update-invest-request")
    ) {
        columns.push({
            title: "Actions",
            dataIndex: "id",
            render: (id) => (
                <div>
                    {checkPermission("update-invest-request") ? (
                        <Button className="btn btn-outline-warning btn-edit btn-sm p-0 me-3">
                            <Link
                                className="color-inherit text-decoration-none py-1 px-2 d-block"
                                to={`/invest-requests/edit/${id}`}
                            >
                                <EditOutlined />
                            </Link>
                        </Button>
                    ) : (
                        <></>
                    )}
                </div>
            ),
        });
    }

    useEffect(() => {
        get("invest-requests").then((res) => {
            setData(res.data.data);
            setTotal(res.data.meta.total);
            setLoading(false);
        });
    }, []);


    const [filterData, setFilterData] = useState({
        filter_key: "",
        filter_value: "",
        filter_key2: "",
        filter_value2: "",
        filter_key3: "",
        filter_value3: "",
    });

    const [sorter, setSorter] = useState({
        sort_by: "",
        order: "",
    });

    const handleFilterKey = (e, name) => {
        setFilterData({ ...filterData, [name]: e });
    };

    const handleFilterVal = (e) => {
        setFilterData({ ...filterData, [e.target.id]: e.target.value });
    };

    const onFilter = (values) => {
        setLoadingSearch(true);


        get(
            `invest-requests?${filterData.filter_key !== '' && filterData.filter_value !== '' ? `filter_key=${filterData.filter_key}&filter_value=${filterData.filter_value}` : ''
            }${filterData.filter_key2 !== '' && filterData.filter_value2 !== '' ? `&filter_key2=${filterData.filter_key2}&filter_value2=${filterData.filter_value2}` : ''
            }${filterData.filter_key3 !== '' && filterData.filter_value3 !== '' ? `&filter_key3=${filterData.filter_key3}&filter_value3=${filterData.filter_value3}` : ''}
            ${sorter.sort_by !== "" && sorter.sort_by !== undefined ? `&sort_by=${sorter.sort_by}` : ""}${sorter.order !== "" ? `&order=${sorter.order}` : ""
            }`
        )
            .then((res) => {
                setData(res.data.data);
                setTotal(res.data.meta.total);
                setLoadingSearch(false);
            })
            .catch((err) => {
                notification.error({
                    message: "Error!",
                    description: err.response.data.message,
                });
                setLoadingSearch(false);
            });
    };

    const clearSearch = () => {
        form.resetFields();
        setFilterData({
            filter_key: "",
            filter_value: "",
        });
        get("invest-requests").then((res) => {
            setData(res.data.data);
            setTotal(res.data.meta.total);
        });
    };
    const [selectedIds, setSelectedIds] = useState({
        ids: []
    });

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedIds({
                ids: selectedRowKeys,
            });
        },
        getCheckboxProps: (record) => ({
            name: record.id,
        }),
    };

    const ExportToExcel = () => {
        post('export-invest-requests', { "exportable_ids": selectedIds.ids })
            .then((res) => {
                console.log(res.data);
                setTimeout(() => {
                    console.log(res.data);
                    const link = document.createElement('a');
                    link.href = res.data.file;
                    link.setAttribute('download', 'invest-requests.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }, 2000);

            })
            .catch((err) => {
                notification.error({
                    message: "Error!",
                    description: err.response.data.message,
                });
            });
    }
    const onChangeTable = (pagination, filters, sorter) => {
        setLoading(true);
        setSorter({
            ...sorter,
            sort_by: sorter.field,
            order: sorter.order == "descend" ? "desc" : "asc",
        });

        onChangeTableHelper('invest-requests', pagination, filterData, sorter)
            .then((res) => {
                setData(res.data.data);
                setTotal(res.data.meta.total);
                setLoading(false);
            })
            .catch((err) => {
                notification.error({
                    message: "Error!",
                    description: err.response.data.message,
                });
                setLoading(false);
            });
    };

    return (
        <div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-6 col-lg-4">
                            <Title level={2} className="text-main mb-2">
                                {" "}
                                Invest Requests
                                {" "}
                            </Title>
                        </div>
                        {
                            selectedIds.ids?.length > 0 ?
                                (
                                    <div className="col-6 col-lg-8 d-flex align-items-center justify-content-end">
                                        <Button type="primary"
                                            onClick={ExportToExcel}
                                            className="p-2 mb-2"
                                            size="large">
                                            {" "}
                                            Export to Excel
                                            {" "}
                                        </Button>
                                    </div>
                                ) : <></>
                        }
                    </div>
                </div>
            </div>

            <div className="grid-margin stretch-card wrapper-content">
                <Form onFinish={onFilter} form={form}>
                    {/* select1 */}
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <Form.Item
                                label="Search By"
                                name="filter_key"
                            >
                                <Select
                                    className="w-100"
                                    showSearch
                                    placeholder="select "
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    onChange={(e) => handleFilterKey(e, 'filter_key')}
                                    options={[
                                        {
                                            value: "id",
                                            label: "Id",
                                        },
                                        {
                                            value: "user_name",
                                            label: "User name",
                                        },
                                        {
                                            value: "user_email",
                                            label: "User email",
                                        },
                                        {
                                            value: "user_phone",
                                            label: "Phone number",
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Item
                                label="Search"
                                name="filter_value"
                                onChange={handleFilterVal}

                            >
                                <Input placeholder="Type to search..." />
                            </Form.Item>
                        </div>

                    </div>
                    {/* select2 */}
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <Form.Item
                                label="Search By"
                                name="filter_key2"
                            >
                                <Select
                                    className="w-100"
                                    showSearch
                                    placeholder="select test "
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    onChange={(e) => handleFilterKey(e, 'filter_key2')}
                                    options={[
                                        {
                                            value: "id",
                                            label: "Id",
                                        },
                                        {
                                            value: "user_name",
                                            label: "User name",
                                        },
                                        {
                                            value: "user_email",
                                            label: "User email",
                                        },
                                        {
                                            value: "user_phone",
                                            label: "Phone number",
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Item
                                label="Search"
                                name="filter_value2"
                                onChange={handleFilterVal}
                            >
                                <Input placeholder="Type to search..." />
                            </Form.Item>
                        </div>
                    </div>
                    {/* select3 */}
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <Form.Item
                                label="Search By"
                                name="filter_key3"
                            >
                                <Select
                                    className="w-100"
                                    showSearch
                                    placeholder="select test "
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    onChange={(e) => handleFilterKey(e, 'filter_key3')}
                                    options={[
                                        {
                                            value: "id",
                                            label: "Id",
                                        },
                                        {
                                            value: "user_name",
                                            label: "User name",
                                        },
                                        {
                                            value: "user_email",
                                            label: "User email",
                                        },
                                        {
                                            value: "user_phone",
                                            label: "Phone number",
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Form.Item
                                label="Search"
                                name="filter_value3"
                                onChange={handleFilterVal}
                            >
                                <Input placeholder="Type to search..." />
                            </Form.Item>
                        </div>
                        <div className="col-12 col-lg-2 d-flex align-items-end">
                            <Form.Item className="w-100">
                                <div className="row">
                                    <div className="col-8">
                                        <Button
                                            block
                                            loading={loadingSearch}
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            {loadingSearch ? "Searching" : "Search"}
                                        </Button>
                                    </div>
                                    <div className="col-4">
                                        <Button
                                            onClick={clearSearch}
                                            className="flex-center"
                                            danger
                                            type="primary"
                                        >
                                            <DeleteOutlined />
                                        </Button>
                                    </div>
                                </div>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
                <TableComponent onChangeTable={onChangeTable} loading={loading} columns={columns} data={data} total={total}
                    rowSelection={{
                        type: "checkbox",
                        ...rowSelection,
                    }} />
            </div>
        </div>
    );
};

export default InvestRequests;
